// Layout
import BaseHeader from "./layout/BaseHeader";
import BaseBody from "./layout/BaseBody";
import BaseTable from "./layout/BaseTable";
import BaseAction from "./layout/BaseActions";
import BaseModal from "./layout/BaseModal";
import { ConfirmProvider, useConfirm } from "./layout/BaseConfirm";
import BaseDrawer from "./layout/BaseDrawer";
import BaseTab from "./layout/BaseTab";
import BaseTree from "./layout/BaseTree";
import BaseEditor from "./layout/BaseEditor";
import BaseEmpty from "./layout/BaseEmpty";
import BaseSkeleton from "./layout/BaseSkeleton";
import BaseError from "./layout/BaseError";
import BaseRequirePermission from "./layout/BaseRequirePermission";
import BaseErrorBoundary from "./layout/BaseErrorBoundary";
import BaseStatusTag from "./data/StatusTag";
import BaseCountryFlag from "./data/CountryFlag";
import { TranslateWithoutHook } from '@utils/IntlMessages';
import BaseInputText from "./inputs/BaseInputText"
import BaseSelectWithSearch from "./inputs/BaseSelectWithSearch";
import BaseDatePicker from "./inputs/BaseDatePicker";
import BaseUploadFile from "./inputs/BaseUploadFile";

// Filters
import BaseFilter from "./filters/BaseFilter";
// Buttons
import BaseButton from "./buttons/BaseButton";
import BaseCreate from "./buttons/BaseCreate";
import BaseUpload from "./buttons/BaseUpload";
import BaseCancel from "./buttons/BaseCancel";
import BaseSave from "./buttons/BaseSave";
import BaseSwitch from "./inputs/BaseSwitch";

export const InputText = BaseInputText;
export const Select = BaseSelectWithSearch;
export const Switch = BaseSwitch;
export const DatePicker = BaseDatePicker;
export const UploadFile = BaseUploadFile;

// Layout
export const HeaderComponent = BaseHeader;
export const BodyComponent = BaseBody;
export const TableComponent = BaseTable;
export const Editor = BaseEditor;
export const ActionComponent = BaseAction;
export const ModalComponent = BaseModal;
export { ConfirmProvider, useConfirm };
export const DrawerComponent = BaseDrawer;
export const TabComponent = BaseTab;
export const TreeComponent = BaseTree;
export const EmptyComponent = BaseEmpty;
export const SkeletonComponent = BaseSkeleton;
export const ErrorComponent = BaseError;
export const RequirePermission = BaseRequirePermission;
export const ErrorBoundary = BaseErrorBoundary;
export const StatusTag = BaseStatusTag;
export const CountryFlag = BaseCountryFlag;
// Filters
export const FilterComponent = BaseFilter;
// Buttons
export const ButtonComponent = BaseButton;
export const CreateButton = BaseCreate;
export const UploadButton = BaseUpload;
export const CancelButton = BaseCancel;
export const SaveButton = BaseSave;
//Components

export const trans = TranslateWithoutHook;